// triggerTypeNo
export const triggerTypeValues = {
  100: "System",
  200: "Manual",
  201: "Courier",
  202: "User",
  300: "Automatic",
  301: "Scheduled",
  302: "Threshold",
  400: "External",
  401: "Webhook",
};

// walletTransactionTypeNo
export const walletTransactionTypeValues = {
  100: "Transfer",
  200: "Deposit",
  300: "Withdrawal",
  400: "Payment",
  500: "Fee",
  501: "Courier Dropoff Fee",
};

// debit_wallet_id = source
// credit_wallet_id = destination
// credit_wallet_id (488) = system account
